import React from 'react'
import RestroomMasterData from '../../data/RestroomMasterData'
import MAP_IMAGE from '../../assets/images/restroom/map/*.svg'

const TAG_ID_CLOSE_BUTTON = 'restroom-map-close'
const TAG_ID_MAP_IMAGE = 'restroom-map-image'
const TAG_CLASS_CLOSE_OVER_IMAGE = 'is-over-image'
const TAG_CLASS_MAP_ZOOM = 'is-zoomed'

export default class Map extends React.Component {
  updateCloseButtonTextColor = () => {
    if (this.closeButton.getBoundingClientRect().bottom < this.mapImage.getBoundingClientRect().top) {
      this.closeButton.classList.remove(TAG_CLASS_CLOSE_OVER_IMAGE)
    } else {
      this.closeButton.classList.add(TAG_CLASS_CLOSE_OVER_IMAGE)
    }
  }

  resizeMap = () => {
    if (this.mapImage.classList.contains(TAG_CLASS_MAP_ZOOM)) {
      this.mapImage.classList.remove(TAG_CLASS_MAP_ZOOM)
    } else {
      this.mapImage.classList.add(TAG_CLASS_MAP_ZOOM)
    }
  }

  render() {
    const {
      facilityId,
      roomId
    } = this.props.match.params

    const imageName = RestroomMasterData.mapImageName(facilityId, roomId)

    return (
      <div className='c-Restroom-map'>
          <button className='c-Restroom-map-close'
            id={TAG_ID_CLOSE_BUTTON}
            onClick={ () => this.props.history.goBack()}
            ref={(obj) => { this.closeButton = obj }}
          >×</button>
          <div className='c-Restroom-map-body'>
            <img className='c-Restroom-map-body-image'
              id={TAG_ID_MAP_IMAGE}
              onLoad={ this.updateCloseButtonTextColor }
              onClick= { this.resizeMap }
              src={MAP_IMAGE[imageName]}
              ref={(obj) => { this.mapImage = obj }}/>
          </div>
      </div>
    )
  }
}